import {
  QUICK_QUIZ_MAX_ANSWER_LENGTH,
  QUICK_QUIZ_MAX_QUESTION_LENGTH,
  QuizContentSubtype,
  SELF_ASSESSMENT_TEST_MAX_ANSWER_LENGTH,
  SELF_ASSESSMENT_TEST_MAX_QUESTION_LENGTH,
  VERIFICATION_TEST_MAX_ANSWER_LENGTH,
  VERIFICATION_TEST_MAX_QUESTION_LENGTH,
} from 'globalTypes'

export const isValidUrl = (string) => {
  try {
    new URL(string)
    return true
  } catch (err) {
    return false
  }
}

export const checkEmailProvider = (email: string) => {
  const invalidEmailPattern = /@(libero\.it|inwind\.it)$/
  return invalidEmailPattern.test(email)
}

export const getValidLanguageForUser = (locale: string) => {
  const validLanguages = ['en', 'it']

  const language = locale.split('-')[0]

  if (language === 'ja') {
    return 'en'
  }

  return validLanguages.includes(language) ? language : 'en'
}

export const createAvatarUrlFromName = (name) => {
  const encodedName = encodeURIComponent(name)
  return `https://ui-avatars.com/api/?name=${encodedName}&length=1&background=f3f4f6&color=4b5563&bold=true&format=png`
}

export const getQuestionMaxLen = (questionType: string) => {
  switch (questionType) {
    case QuizContentSubtype.self_assessment_test:
      return SELF_ASSESSMENT_TEST_MAX_QUESTION_LENGTH
    case QuizContentSubtype.verification_test:
      return VERIFICATION_TEST_MAX_QUESTION_LENGTH

    default:
      return QUICK_QUIZ_MAX_QUESTION_LENGTH
  }
}

export const getAnswerMaxLen = (questionType: string) => {
  switch (questionType) {
    case QuizContentSubtype.self_assessment_test:
      return SELF_ASSESSMENT_TEST_MAX_ANSWER_LENGTH
    case QuizContentSubtype.verification_test:
      return VERIFICATION_TEST_MAX_ANSWER_LENGTH

    default:
      return QUICK_QUIZ_MAX_ANSWER_LENGTH
  }
}
